// src/components/products/sensaphone/SensaphoneAccessoriesList.jsx
import React from "react";
import ProductContainerImage from "../ProductContainerImage";

/** Normalize Strapi media/repeatable: array, single object, or null. */
const toPdfEntries = (productPdf) => {
  if (!productPdf) return [];
  if (Array.isArray(productPdf)) return productPdf.filter(Boolean);
  return [productPdf];
};

// expects safeText function passed in
const SensaphoneAccessoriesList = ({ items, safeText }) => {
  if (!items || items.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <p>No accessories products available.</p>
      </div>
    );
  }

  return (
    <div className="p-6 sm:p-8 lg:p-10 space-y-6 sm:space-y-8">
      {items.map((item, index) => {
        const imageUrl = item.image?.[0]?.url;
        const productName = safeText(item.name);
        const subtitle = safeText(item.subtitle);
        const pdfEntries = toPdfEntries(item.product_pdf).filter(
          (p) => p?.download_file?.url
        );

        return (
          <div
            key={item.id || index}
            className="group flex flex-col md:flex-row gap-4 sm:gap-6 md:gap-8 bg-white/95 rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-0.5"
          >
            {/* Image */}
            <div className="flex shrink-0 items-center justify-center md:w-auto">
              {imageUrl ? (
                <ProductContainerImage
                  sizing="intrinsic"
                  src={imageUrl}
                  alt={productName || "Accessory"}
                />
              ) : (
                <div className="product-container-image-placeholder">No Image</div>
              )}
            </div>

            {/* Content */}
            <div className="flex-1 px-4 sm:px-6 py-4 sm:py-5 flex flex-col justify-between">
              <div>
                {productName && (
                  <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-900 group-hover:text-green-700 transition-colors duration-200">
                    {productName}
                  </h3>
                )}
                {subtitle && (
                  <p className="mt-2 text-sm sm:text-base text-gray-600 leading-relaxed whitespace-pre-line">
                    {subtitle}
                  </p>
                )}
              </div>

              {pdfEntries.length > 0 && (
                <div className="mt-4 flex flex-col gap-2 sm:gap-3">
                  {pdfEntries.map((pdf, pdfIndex) => {
                    const downloadTitle = safeText(pdf?.download_title);
                    const downloadFileUrl = pdf.download_file.url;
                    return (
                      <button
                        key={pdf?.id ?? pdfIndex}
                        type="button"
                        onClick={() => {
                          window.open(
                            downloadFileUrl,
                            "_blank",
                            "noopener,noreferrer"
                          );
                        }}
                        className="inline-flex w-fit items-center gap-2 text-sm sm:text-base font-medium text-green-700 hover:text-green-900 text-left"
                      >
                        <span>
                          {downloadTitle || "Download product PDF"}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SensaphoneAccessoriesList;





